import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../Config/firebase";

/**
 * Registra eventos de histórico de um material
 *
 * @param {Object} params
 * @param {string} params.materialId - ID do material
 * @param {string} params.acao - CRIACAO | EDICAO | ALTERACAO_STATUS
 * @param {string|null} params.campo - Campo alterado (ex: Status)
 * @param {any|null} params.valorAnterior - Valor anterior
 * @param {any|null} params.valorNovo - Valor novo
 * @param {Object} params.usuario - Dados do usuário
 */
export async function registrarHistorico({
  materialId,
  acao,
  campo = null,
  valorAnterior = null,
  valorNovo = null,
  usuario
}) {
  if (!materialId) {
    throw new Error("registrarHistorico: materialId é obrigatório");
  }

  if (!acao) {
    throw new Error("registrarHistorico: ação é obrigatória");
  }

  if (!usuario?.uid) {
    throw new Error("registrarHistorico: usuário inválido");
  }

  const payload = {
    acao,
    campo,
    valorAnterior,
    valorNovo,
    usuario: {
      uid: usuario.uid,
      nome: usuario.nome || "Não informado",
      email: usuario.email || "",
      tipo: usuario.tipo || "desconhecido"
    },
    data: Timestamp.now()
  };

  await addDoc(
    collection(
      db,
      "tblListaMateriaisCadastrados",
      materialId,
      "historico"
    ),
    payload
  );
}
